/* __next_internal_client_entry_do_not_use__ TopShopBadge auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TopShopEducationTooltip } from "@faire/retailer-visitor-shared/components/TopShop/TopShopTooltip";
import { ActiveTrophy } from "@faire/web--source/slate/icons/Trophy";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var TopShopBadge = function(param) {
    var tooltipPosition = param.tooltipPosition, hideUnderline = param.hideUnderline, _param_iconSize = param.iconSize, iconSize = _param_iconSize === void 0 ? "18px" : _param_iconSize, typographyVariant = param.typographyVariant;
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsx(TopShopEducationTooltip, {
        hidden: isMobile,
        position: tooltipPosition,
        icon: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ActiveTrophy, {
                    fontSize: iconSize,
                    titleAccess: ""
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: 4
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    style: {
                        textDecoration: isMobile || hideUnderline ? undefined : "underline"
                    },
                    variant: typographyVariant,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "S/Y52l",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Top Shop"
                            }
                        ]
                    })
                })
            ]
        })
    });
};
